module.exports = __webpack_public_path__ + "img/cbl2n1.ab97db51.gif";